import { useDispatch, useSelector } from "react-redux";
import "./Stock.css";
import ImmoHeader from "../../componnents/ImmoHeader";
import ListeLots from "../../componnents/ListeLots";
import ListeProgrammes from "../../componnents/ListeProgrammes";
import ListeCarte from "../../componnents/ListeCarte";
import {
  setActiveView,
  fetchLots,
  fetchProgrammes,
} from "../../../../redux/actions/immobilierActions";
import Pagination from "../../../../components/commons/Pagination";
import { useEffect, useState } from "react";
import AddProperty from "./components/AddProperty";
import { openModal } from "../../../../redux/actions/modalActions";
import AddProgramme from "./components/AddProgramme";

const Stock = ({
  listeDesProgrammes,
  currentPage,
  onPageChange,
  pagination,
}) => {
  const [filterInput, setFilterInput] = useState("");
  const dispatch = useDispatch();
  const { activeView, lots, lotsLoading, lotsError, lotsPagination } =
    useSelector((state) => state.immobilierReducer);

  useEffect(() => {
    if (activeView === "lots") {
      dispatch(fetchLots(lotsPagination.page));
    }
  }, [dispatch, activeView, lotsPagination.page]);

  const handleLotsPageChange = (page) => {
    dispatch(fetchLots(page));
  };
  
  const handleSearch = () => {
    if (activeView === "lots") {
      // Search for lots
      dispatch(fetchLots(1, 25, "updatedAt", filterInput));
    } else if (activeView === "programmes" || activeView === "carte") {
      // Search for programs (also applies to map view since it uses the same data)
      dispatch(fetchProgrammes(1, 25, "updatedAt", filterInput));
    }
  };
  const handleAddProperty = () => {
    dispatch(
      openModal({
        title: `Ajouter une propriété`,
        content: <AddProperty />,
      })
    );
  };
  const handleAddProgramme = () => {
    dispatch(
      openModal({
        title: `Ajouter un programme`,
        content: <AddProgramme />,
      })
    );
  };
  return (
    <div>
      <ImmoHeader
        activeView={activeView}
        setActiveView={(view) => dispatch(setActiveView(view))}
        deepSearch={true}
        filterInput={filterInput}
        setFilterInput={setFilterInput}
        handleSearch={handleSearch}
      />

      {activeView === "lots" ? (
        <>
          <div className="mt-20">
            <button
              onClick={handleAddProperty}
              className="radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
            >
              Ajouter un Lot
            </button>
          </div>
          <ListeLots lots={lots} loading={lotsLoading} error={lotsError} />
          <Pagination
            currentPage={lotsPagination.page}
            totalPages={lotsPagination.pageCount}
            onPageChange={handleLotsPageChange}
            className="mt-20"
          />
        </>
      ) : null}
      {activeView === "programmes" ? (
        <>
          <div className="mt-20">
            <button
              onClick={handleAddProgramme}
              className="radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
            >
              Ajouter un Programme
            </button>
          </div>
          <ListeProgrammes listeDesProgrammes={listeDesProgrammes} />
          <Pagination
            currentPage={currentPage}
            totalPages={pagination.pageCount}
            onPageChange={onPageChange}
            className="mt-20"
          />
        </>
      ) : null}
      {activeView === "carte" ? (
        <>
          <ListeCarte listeDesProgrammes={listeDesProgrammes} />
          <Pagination
            currentPage={currentPage}
            totalPages={pagination.pageCount}
            onPageChange={onPageChange}
            className="mt-20"
          />
        </>
      ) : null}
    </div>
  );
};

export default Stock;
